import type { IClient, IConsultation } from '../store/types';

/**
 * Returns true if the consultation is a group therapy session.
 * Uses is_group from API when present; otherwise max_participants >= 2 or heuristic by client name.
 */
export function isGroupConsultation(
  consultation: IConsultation | null | undefined,
  client: Pick<IClient, 'full_name'> | null | undefined,
): boolean {
  if (!consultation) return false;
  if (consultation.is_group === true) return true;
  if (consultation.is_group === false) return false;
  if (consultation.max_participants != null && consultation.max_participants >= 2) return true;
  if (client?.full_name && client.full_name.toLowerCase().includes('групп')) return true;
  return false;
}

/** Подпись формата встречи для журнала: только явный offline — очная; иначе (в т.ч. без свойства) — онлайн. */
export function consultationMeetFormatLabel(
  consultation: Pick<IConsultation, 'consultation_type'> | null | undefined,
): string {
  return consultation?.consultation_type === 'offline' ? 'Очная встреча' : 'Онлайн встреча';
}
